<template>
    <el-dialog
            width="504px"
            :visible.sync="isShow"
            top="182px"
            :title="title"
            append-to-body
            :modal="false"
            :close-on-click-modal="false">
        <div style="margin-bottom: 18px;">
            <el-input
                    placeholder="请输入"
                    v-model="text"
                    :maxlength="maxlength"
            >
            </el-input>
        </div>
        <div class="footer">
            <el-button class="input-btn" @click="cancel" size="small">取消</el-button>
            <el-button type="primary" class="input-btn" :style="{marginLeft: '24px'}" @click="confirm" size="small">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: 'CreateSource',
        watch: {
            isShow(val) {
                if (!val) {
                    this.resolve && this.resolve(null)
                    this.resolve = null;
                }
            }
        },
        data() {
            return {
                resolve: null,
                isShow: false,
                text: '',
                title: '',
                maxlength: 30
            }
        },
        methods: {
            show({title, maxlength = 30}) {
                this.title = title;
                this.text = '';
                this.isShow = true;
                this.maxlength = maxlength;
                return new Promise(resolve => {
                    this.resolve = resolve;
                })
            },
            cancel() {
                this.isShow = false;
            },
            async confirm() {
                if (!this.text) {
                    this.$message.error('文字不能为空')
                    return;
                }
                this.resolve && this.resolve(this.text);
                this.resolve = null;
                this.isShow = false
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 17px;
        font-weight: 500;
        color: #2e2e2e;
        margin-bottom: 13px;
    }
    .footer {
        margin-top: 23px;
        text-align: center;
    }
</style>